import { useEffect } from 'react';
import CharCount from '../../../components/charCount/CharCount';
import DropdownReg from '../../../components/dropdownReg/DropdownReg';
import OrgRoomGuestSelector from '../../../components/orgRoomGuestSelector/OrgRoomGuestSelector';
import OrgVehicleSelector from '../../../components/orgVehicleSelector/OrgVehicleSelector';
import { isGroupOptions } from './constants/TripBookingConstant';

export default function CustomTrip({
    muBookData,
    setMuBookData,
    vehicleNames,
    handleAmount,
    vehicleCounts,
    setVehicleCounts
}) {
    return (
        <>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Group</label>
                <div className='dropRegInputDiv'>
                    <select
                        value={muBookData.customTrip.isGroup}
                        name='isGroup'
                        onChange={(e) =>
                            handleAmount(
                                {
                                    target: {
                                        name: 'isGroup',
                                        value: e.target.value === 'true'
                                    }
                                },
                                'customTrip',
                                false
                            )
                        }
                        required={true}
                        className='dropRegSelect'
                    >
                        <option value='-1'>Select</option>
                        {isGroupOptions.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={String(val.value)}>
                                    {val.label}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <>
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Room</label>
                    <div className='dropRegInputDiv'>
                        <OrgRoomGuestSelector
                            label={'Rooms'}
                            rooms={muBookData.customTrip.rooms}
                            setRooms={(updatedRooms) =>
                                setMuBookData((prev) => ({
                                    ...prev,
                                    customTrip: {
                                        ...prev.customTrip,
                                        rooms: updatedRooms
                                    }
                                }))
                            }
                        />
                    </div>
                </div>
                {/* <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Bed</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={muBookData.customTrip.bed}
                                name='bed'
                                onChange={(e) => handleAmount(e, 'customTrip')}
                                type='Number'
                                placeholder={`Number of beds`}
                                className='dropRegSelect'
                            ></input>
                            <CharCount string={muBookData.customTrip.bed} min={3} limit={7} />
                        </div>
                    </div> */}
                {!muBookData?.customTrip.isGroup && (
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Vehicle</label>
                        <div className='dropRegInputDiv'>
                            <OrgVehicleSelector
                                label={'Select Vehicle'}
                                options={vehicleNames}
                                setCustomBooking={setMuBookData}
                                vehicleCounts={vehicleCounts}
                                setVehicleCounts={setVehicleCounts}
                            />
                        </div>
                    </div>
                )}
            </>
        </>
    );
}
